var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.consultWarehouse() && (!_vm.warehouse_selected || !_vm.ubication_selected))?_c('b-card',{staticClass:"px-1 pb-0 mb-1",attrs:{"no-body":""}},[_c('MultiSelectWarehouse',{attrs:{"onlyWithLocations":true}})],1):_vm._e(),_c('CardSelectWarehouse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }